export default __webpack_public_path__ + "static/media/leaf-marker.850d74cc.png";